import { Adresse } from '../../../../api';
import { AdresseModel } from '../../../../models/AdresseModel';

export const VERSENDER = 'versender';
export const EMPFAENGER = 'empfaenger';
export const ABWEICHENDE_BELADESTELLE = 'beladestelle';
export const ABWEICHENDE_ENTLADESTELLE = 'entladestelle';
export const ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER =
  'rechnungsempfversender';
export const NEUTRALE_ABSENDERADRESSE = 'versenderneutral';
export const ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER =
  'rechnungsempfempfaenger';
export const REGISTRATUR = 'registratur';
export const NACHNAHME_EMPFAENGER = 'nachnahmeempfaenger';

export const emptyAdresse: AdresseModel = {
  id: undefined,
  copyId: undefined,
  einmaladresse: false,
  fremdid: undefined,
  fremdnummer: undefined,
  hausnummer: undefined,
  inUebertragung: false,
  kontakt: undefined,
  kurzname: undefined,
  land: {
    id: undefined,
    bezeichnung: '',
    lkz: '',
  },
  lkz: '',
  mandant: undefined,
  mandantId: undefined,
  matchcode: undefined,
  name: '',
  origin: undefined,
  originsBezLang: '',
  ort: '',
  ortsteil: '',
  ortsteilname: undefined,
  plz: '',
  strasse: '',
  usteuerid: '',
  zeile2: '',
  zeile3: '',
  zusatz: '',
  unsichtbar: false,
  typ: '',
  telefon: '',
  postfach: '',
  ortPostfach: '',
  mailTrackTrace: '',
};

const getAdressenTypen = () => [
  VERSENDER,
  EMPFAENGER,
  ABWEICHENDE_BELADESTELLE,
  ABWEICHENDE_ENTLADESTELLE,
  ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER,
  NEUTRALE_ABSENDERADRESSE,
  ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER,
  NACHNAHME_EMPFAENGER,
  REGISTRATUR,
];

export const getAdresseTypLabel = (adresseTyp: string): string => {
  switch (adresseTyp) {
    case VERSENDER:
      return 'Versender';
    case EMPFAENGER:
      return 'Empfänger';
    case ABWEICHENDE_BELADESTELLE:
      return 'Abweichende Beladestelle';
    case ABWEICHENDE_ENTLADESTELLE:
      return 'Abweichende Entladestelle';
    case ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER:
      return 'Abweichender Rechnungsempfänger';
    case ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER:
      return 'Abweichender Rechnungsempfänger';
    case NACHNAHME_EMPFAENGER:
      return 'Nachnahme Empfänger';
    case REGISTRATUR:
      return 'Registratur';
    case NEUTRALE_ABSENDERADRESSE:
      return 'Neutrale Absenderadresse';
    default:
      return 'unbekannter Adressetyp ' + adresseTyp;
  }
};

export const setAdressePayloadByTyp = (
  adressen: AdresseModel[],
  typ: string
): any => {
  const result = findAdresseByTyp(adressen, typ);
  return result && result.id && result.id !== '' ? result : undefined;
};

export const findAdresseByTyp = (adressen: any[], typ: string): any => {
  let result = {};
  if (adressen) {
    result = adressen.find(adresse => adresse.typ === typ);
  }
  return result ? result : {};
};

export const resetAdresseToDefault = (adresse: any) => {
  adresse.id = null;
  adresse.matchcode = '';
  adresse.fremdnummer = '';
  adresse.name = '';
  adresse.zeile2 = '';
  adresse.zeile3 = '';
  adresse.strasse = '';
  adresse.hausnummer = '';
  (adresse.land = {
    id: undefined,
    bezeichnung: '',
    lkz: '',
  }),
    (adresse.lkz = '');
  adresse.ort = '';
  adresse.plz = '';
  adresse.kontakt = '';
  adresse.telefon = '';
  adresse.ortsteil = '';
  adresse.kurzname = '';
  adresse.fremdid = null;
  adresse.postfach = '';
  adresse.ortPostfach = '';
  adresse.usteuerid = '';
  adresse.mailTrackTrace = '';
  adresse.einmaladresse = false;
  adresse.unsichtbar = false;
  adresse.mandant = null;
  return adresse;
};

export const replaceAdresseByTyp = (
  adressen: any[],
  ersatzAdresse: Adresse,
  adresseTyp: string
): any => {
  let resultAdressen = [];
  if (adressen) {
    resultAdressen = adressen.filter(adresse => adresse.typ !== adresseTyp);
    resultAdressen.push(ersatzAdresse);
  }
  return resultAdressen ? resultAdressen : [];
};

/**
 *
 * @param adresseTyp
 */
export const getGridCellActiveComponentLabel = (adresseTyp: string): string => {
  if (
    adresseTyp == EMPFAENGER ||
    adresseTyp == ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER
  ) {
    return EMPFAENGER;
  } else {
    return VERSENDER;
  }
};

export const addAdresseTypToAdresse = (
  adressetyp: string,
  adresse: Adresse
) => {
  return { ...adresse, ['typ']: adressetyp };
};

export const initAdressen = (): AdresseModel[] => {
  const adressen = getAdressenTypen().map(adresseTyp => {
    return { ...emptyAdresse, typ: adresseTyp };
  });
  return adressen;
};
